
import { defineComponent, ref, onMounted, PropType, computed } from "vue";
import { useDayjs } from '@/core/hook/useDayjs';
const { dayjs } = useDayjs();
import { MdPerson, MdRemove, IosArrowForward } from "@vicons/ionicons4";
import { useStore, mapGetters } from "vuex";
import { Module, Actions, Getters } from "@/store/enums/homeEnums";
import {
  Module as ParticipationModule,
  Actions as ParticipationActions,
  Getters as ParticipationGetters,
  Params as ParticipationParams
} from "@/store/enums/participationEnums";

import {
  Module as HosterModule,
  Actions as HosterActions,
  Getters as HosterGetters
} from "@/store/enums/hosterEnums";

import { useThemeVars, useDialog } from "naive-ui";
import { changeColor } from "seemly";
import {
  EventStatus as ParamEventStatus,
  ParticapantStatus as ParamParticapantStatus,
  ResponseStatus as ParamResponseStatus,
  IsResolution as ParamIsResolution,
  HasReply as ParamHasReply
} from "@/store/enums/paramsEnums";

import inviteEventModel from "@/core/models/share/inviteEvent.interface";
import voteEventCountModel from "@/core/models/share/voteEventCount.interface";
import voteEventModel from "@/core/models/share/voteEvent.interface";
import invitePersonModel from "@/core/models/share/invitePerson.interface";
import {
  Module as ExposedModule,
  Actions as ExposedActions,
  Mutations as ExposedMutations,
  Getters as ExposedGetters
} from "@/store/enums/exposedEnums";
import { useI18n } from "vue-i18n";
export default defineComponent({
  name: "participantModalReplayListSortByAgreeCount",
  components: {
    MdPerson,
    MdRemove,
    IosArrowForward
  },
  props: {
    event: { type: Object as PropType<inviteEventModel | null> }
  },
  setup(props: any, context: any) {
    const store = useStore();
    const { t, locale } = useI18n();
    const personNone = computed(
      // () => store.getters[HosterModule.desc + HosterGetters.InvitMember]
      function() {
        let ori: Array<invitePersonModel> =
          store.getters[ExposedModule.desc + ExposedGetters.InvitMember];
        ori = ori.filter(
          (r: invitePersonModel) => r.Status == ParamParticapantStatus.None
        );

        // var result = eventResponse.value.filter((e: voteEventModel) => e.EventScheduleId == eventScheduleId && e.Status != null)
        let name = ori.map((a: invitePersonModel) => a.Name).join(", ");
        let count = ori.length;

        return { name: name, count: count, data: ori };
      }
    );

    const personAll = computed(
      // () => store.getters[HosterModule.desc + HosterGetters.InvitMember]
      function() {
        let ori: Array<invitePersonModel> =
          store.getters[ExposedModule.desc + ExposedGetters.InvitMember];
        ori = ori.filter(
          (r: invitePersonModel) => r.Status == ParamParticapantStatus.All
        );

        // var result = eventResponse.value.filter((e: voteEventModel) => e.EventScheduleId == eventScheduleId && e.Status != null)
        let name = ori.map((a: invitePersonModel) => a.Name).join(", ");
        let count = ori.length;

        return { name: name, count: count, data: ori };
      }
    );

    const resNone = computed<invitePersonModel>(
      () =>
        store.getters[ExposedModule.desc + ExposedGetters.EventPartRespStatus]
    );

    const responseList = computed<Array<voteEventCountModel>>(() =>
      store.getters[
        ExposedModule.desc + ExposedGetters.EventSchedularCountWithMyResponse
      ](ParticipationParams.SortByAgreeCount)
    );

    const eventResponse = computed<Array<voteEventModel>>(
      () => store.getters[ExposedModule.desc + ExposedGetters.EventResponse]
    );
    function eventResponseFilter(eventScheduleId: string) {
      var result = eventResponse.value.filter(
        (e: voteEventModel) =>
          e.EventScheduleId == eventScheduleId && e.Status != null
      );
      let name = result.map(a => a.Name).join(", ");
      return name;
    }
    async function voteNone(resNone: invitePersonModel, status: string) {
      let param = {
        EventParticipantId: resNone.EventParticipantId,
        Status: status
      };

      await store.dispatch(
        ExposedModule.desc + ExposedActions.HandMyEventVoteNone,
        param
      );

      await store.dispatch(
        `${ExposedModule.desc}${ExposedActions.LoadExposed}`,
        { participatantId: param.EventParticipantId }
      );
    }
    async function userVote(
      evntId: string,
      timeId: string,
      usrId: string,
      resId: string,
      status: string
    ) {
      let param = {
        EventHeaderId: evntId,
        EventScheduleId: timeId,
        EventParticipantId: usrId,
        ParticipantResponseId: resId,
        Status: status
      };

      await store.dispatch(
        ExposedModule.desc + ExposedActions.HandMyEventVote,
        param
      );
      await store.dispatch(
        `${ExposedModule.desc}${ExposedActions.LoadExposed}`,
        { participatantId: param.EventParticipantId }
      );
    }
    function dateDisplay(date: string) {
      return dayjs( date).format("YYYY/MM/DD ddd");
    }

    function startTimeDisplay(date: string) {
      return dayjs( date).format("HH:mm");
    }

    function endTimeDisplay(date: string) {
      return dayjs( date).format("HHmm") == "0000"
        ? "24:00"
        : dayjs( date).format("HH:mm");
    }

    function percentage(numerator: number, denominator: number) {
      return Number(((numerator * 100) / denominator).toFixed(0));
    }

    onMounted(() => {});

    return {
      ParamResponseStatus,
      ParamParticapantStatus,
      responseList,
      userVote,
      themeVars: useThemeVars(),
      changeColor,
      dateDisplay,
      startTimeDisplay,
      endTimeDisplay,
      percentage,
      eventResponseFilter,
      voteNone,
      resNone,
      personNone,
      t,
      personAll
    };
  }
});
